define.alias("shared/components/shared/post/secondary/hashtag-suggestions/tabs", "media/components/shared/post/secondary/hashtag-suggestions/tabs");